import { Router } from '@angular/router';
import { Component, OnInit, TemplateRef } from '@angular/core';
import Swal from 'sweetalert2';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MainService } from '../../services/main.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss']
})
export class DepartmentComponent implements OnInit {
  depName = '';
  vision = '';
  message = '';
  objective = '';
  teachers = '';
  jobs = '';
  list = [];
  programs = '';
  degree = '';
  system: any = '';
  img1: any = '';
  img2: any = '';
  branch: any = '';
  subDeps = '';
  modalRef: BsModalRef;
  public v1: any = '';
  v2: any = '';
  v3: any = '';
  v4: any = '';
  v5: any = '';
  v6: any = '';
  flage: boolean = false;
  register: FormGroup;

  public govs: any[];
  public quals: any[];
  public sections: any[];
  public branches: any[];
  public conns: any[];

  public sectionData: any[];
  public video_url: any = '';
  public years: any[];


  constructor(private api: MainService, private router: Router, private modalService: BsModalService, private fb: FormBuilder, private domSanitizer: DomSanitizer) {
    //console.log(this.router.url);
    this.register = new FormGroup({
      nationalId: new FormControl(''),
      name: new FormControl(''),
      qualification: new FormControl(''),
      graduateYear: new FormControl(''),
      stateId: new FormControl(''),
      sectionId: new FormControl(''),
      branchId: new FormControl(''),
      acquaintanceWay: new FormControl(''),
      phone: new FormControl(''),
      cityId: new FormControl(''),
      grade: new FormControl(''),
    });
    this.createForm();



    switch (this.router.url) {
      case '/sec1':
        this.getSectionData(1);
        break;
      case '/sec2':
        this.getSectionData(2);
        break;
      case '/sec3':
        this.getSectionData(3);
        break;
      case '/sec4':
        this.getSectionData(4);
        break;
      case '/sec5':
        this.getSectionData(5);
        break;
      case '/sec6':
        this.getSectionData(6);
        break;
      case '/sec7':
        this.getSectionData(7);
        break;
      case '/sec8':
        this.getSectionData(8);
        break;
      case '/sec9':
        this.getSectionData(9);
        break;
      case '/sec10':
        this.getSectionData(10);
        break;
      case '/sec11':
        this.getSectionData(11);
        break;
      case '/sec12':
        this.getSectionData(12);
        break;
      case '/sec13':
        this.getSectionData(13);
        break;
      case '/sec14':
        this.getSectionData(14);
        break;
      case '/sec15':
        this.getSectionData(15);
        break;
      case '/sec16':
        this.getSectionData(16);
        break;
      case '/sec17':
        this.getSectionData(17);
        break;
      case '/sec18':
        this.getSectionData(18);
        break;
      case '/sec19':
        this.getSectionData(19);
        break;
      case '/sec20':
        this.getSectionData(20);
        break;
      case '/sec21':
        this.getSectionData(21);
        break;
      case '/sec22':
        this.getSectionData(22);
        break;
      case '/sec23':
        this.getSectionData(23);
        break;
      case '/sec24':
        this.getSectionData(24);
        break;
      case '/sec25':
        this.getSectionData(25);
        break;
      /* -------------------------- Hotels -------------------------- */
      case '/hotels':
        this.img1 = 'a01.png';
        this.img2 = 'a02.png';
        this.v4 = true;
        this.depName = 'قسم السياحية والفنادق';
        // tslint:disable-next-line: max-line-length
        this.vision = 'تسعى أكاديمية 6 أكتوبر لأن تكون الرائدة في مصر فى مجال قسم السياحة والفنادق ، كما تسعى الى تميز خريجها لتكون أفضل الكوادر في مجالي السياحة والفنادق وأن تجتذب أعلي الكفاءات العلمية و للتطوير الدائم المتلائم مع احتياجات سوق العمل السياحي والفندقي.';
        // tslint:disable-next-line: max-line-length
        this.message = 'تقوم الأكاديمية بتوفير الخدمات التعليمية والتدريبية المتميزة للدارسين فى مجالات السياحة والفنادق وتأهيلهم عمليا للمنافسة فى سوق العمل محليا وإقليميا وتحقيق الريادة فى مجالات التعليم والتدريب والمساهمة فى خدمة المجتمع من خلال تقديم كوادر تستطيع النهوض بالمجال السياحي والفندقي';
        // tslint:disable-next-line: max-line-length
        this.objective = 'يهدف قسم السياحة والفنادق لتخريج كوادر على مستوي علمي وعملي عالي جدا في مجالي السياحة والفنادق قادر على إحداث الفرق في هذا المجال بحيث يكون مثال يحتذى به من خلال عمله في الفنادق الكبرى او القرى السياحية ويكون قادر على اداء خدمة مميزة ترقي بمستوى الخدمات الفنية في المجالين السياحي والفندقي';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم القسم نخبة من الاساتذة والمعيدين لتدريس المواد الأكاديمية وكذلك فنين من ذوي الخبرات الفنية العالية في مجالي السياحة والفنادق لتدريس المواد العملية';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يهدف القسم الى تأهيل الخريج ليكون قادر على الاندماج المباشر في سوق العمل الفندقي والقيام بمختلف اعمال الخدمات الفندقية من الضيافة والهوس كيبينج.';
        this.list = [];
        this.system = 'عامان دراسيان 4 ترم.';
        // tslint:disable-next-line: max-line-length
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- Width -------------------------- */
      case '/width':
        this.img1 = 'b01.png';
        this.img2 = 'b02.png';
        this.v1 = true;
        this.depName = 'قسم المساحة والخرائط';
        // tslint:disable-next-line: max-line-length
        this.vision = 'التميز والجودة في الاداء وتحقيق الريادة والتميز في مجال المساحة والخرائط لخدمة المجتمع بأخصائي مساحة تقني ذو كفاءة عالية.';
        // tslint:disable-next-line: max-line-length
        this.message = 'تأهيل خريجي القسم تأهيلا تقنيا في مجال المساحة والخرائط وبما يسهم في تلبية احتياجات سوق العمل في المشاريع الهندسية المختلفة (مساحية وانشائية) على اختلاف احجامها لدوائر القطاع العام والخاص';
        // tslint:disable-next-line: max-line-length
        this.objective = 'يهدف قسم المساحة والخرائط الى ما يلي تخريج كوادر تقنية مؤهلة للقيام بأعمال المسح الارضي والتصويري أعمال الرفع التفصيلي الطبوغرافي و إنشاء الشبكات وحساب كميات الحفر والردم ورفع حدود الأرضي وحساب مساحتها فضلا عن اعمال التسوية لمعالم سطح الارض الطبيعية منها والاصطناعية باستخدام الاجهزة المساحية التقليدية و الحديثة (اجهزة المحطة الكاملة Total Station) واجهزة التوقيع العالمي الملاحي والمساحي (GPS ،. يضاف الى ذلك اعداد ورسم خرائط الطبوغرافية ، العقارية ، الموضوعية ، والتفصيلية . وكذلك استخدام نظم المعلومات الجغرافية, . (GIS) من اجل بناء قاعدة بيانات وانتاج الخرائط الرقمية في مختلف المجالات. بالإضافة إلى أجهزة المسح التقليدية كالتيدوليت والموازين يتوفر في القسم مجموعه كبيره لأحدث ما توصلت إليه أجهزة المسح الإلكترونية وأجهزة المحطات الشاملة وأجهزة تحديد المواقع بالأقمار الصناعية وزارة الزراعة والري والصرف – وزارة الصحة والسكان – وزارة الصناعة والتجارة والهيئة العامة للمساحة بالإضافة الى فرص السفر لجميع الدول العربية والخاصة الخليجية, ويقوم القسم بإستخدام أحدث الحاسبات الآلية لإنتاج الخرائط بمختلف أشكالها ومقاييسها ، ويتم حساب المساحات والكميات والإحداثيات من خلال برامج يقوم القسم باستخدام أحدث الحاسبات الآلية لإنتاج الخرائط بمختلف أشكالها ومقاييسها ، ويتم حساب المساحات والكميات والإحداثيات من خلال برامج مساحية Office - ARC GIS- AutoCAD- Civil 3D- Surfer';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم القسم نخبة من مهندسي المساحة الذين قاموا بإدارة عدة مشاريع مما أكسبهم خبرة عالية ، وكذلك تحرص الأكاديمية على رفع مستوى كفاءتهم بما تتيحه لهم من حضور دورات داخلية وخارجية في مختلف علوم المساحة';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يهدف القسم الى تأهيل الخريج ليكون قادر على القيام بالمهام الاتية';
        this.list = [{
          name: 'اجراء الرفع المساحي ذات الدقة العالية للمشاريع الهندسية (السدود ،الخزانات ، الجسور ، الانفاق , وطرق المطارات)',
        }, {
          name: 'من اجل بناء قاعدة بيانات وانتاج الخرائط الرقمية في مختلف المجالات – شبكات المياه – شبكات الكهرباء- الصرف الصحي – الطرق – المصانع الكبرى و غيرها استخدام نظم المعلومات الجغرافية',
        }, {
          name: 'حساب كميات الحفر والردم الازمة للمشروعات كمشروعات الطرق والتسويات',
        }];
        //this.subDeps = 'بالإضافة إلى أجهزة المسح التقليدية كالتيدوليت والموازين يتوفر في القسم مجموعه كبيره لأحدث ما توصلت إليه أجهزة المسح الإلكترونية وأجهزة المحطات الشاملة وأجهزة تحديد المواقع بالأقمار الصناعية وزارة الزراعة والري والصرف – وزارة الصحة والسكان – وزارة الصناعة والتجارة والهيئة العامة للمساحة بالإضافة الى فرص السفر لجميع الدول العربية والخاصة الخليجية'
        // tslint:disable-next-line: max-line-length
        this.programs = 'عامان دراسيان 4 ترم.';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- Electronic -------------------------- */
      case '/electronic':
        this.img1 = 'e01.png';
        this.img2 = 'e02.png';
        this.v6 = true;
        this.depName = 'قسم الهندسة الإلكترونية';
        // tslint:disable-next-line: max-line-length
        this.vision = 'يهدف قسم الهندسة الإلكترونية إلى تأهيل خريجين متميزين ذوى كفاءة ومهارة عالية التميز إقليمياً في مجال الهندسة الالكترونية وتطبيقاتها. و إعداد الكوادر الفنية وتطوير مهاراتهم وقدراتهم لمواكبة احتياجات سوق العمل.';
        // tslint:disable-next-line: max-line-length
        this.message = 'اعداد كوادر فنية مؤهلة ومزودة بالمعرفة والتقنية الحديثة فى مجالات الهندسة الإلكترونية المختلفة من خلال تعليم اكاديمى متميز وبيئة بحثية وفق المعايير العالمية وشراكة مجتمعية فاعلة';
        // tslint:disable-next-line: max-line-length
        this.objective = 'الفهم الجيد لتخريج جيل قادر على السير فى التحديات فى مجال الصيانة وفهم الدوائر الالكترونية والمنطق والتكييف مع العمل فى المؤسسات التى تعمل فى المجال الإلكتروني. توفير بيئة تعليمية متميزة لطلاب القسم وفق أحدث البرامج التى تساهم فى تميز الخرجين.إكساب الطلبة المعارف والمهارات الفنية فى الهندسة الالكترونية وتزويدهم بالمفاهيم. العمل على تزويد المجتمع بالمتخصصين في الهندسة الالكترونية تطوير مهارات الكوادر الفنية';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم قسم الخدمات البترولية بعض الاساتذة المهندسين ومعيدين من الجامعات المصرية ذوى الخبرة فى مجالات الهندسة الإلكترونية.';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'فرص عمل دارسين الهندسة الإلكترونية يتاح لهم الكثير من الفرص الوظيفية التى تمكنهم من العمل فى إحدى شركات الهندسة الإلكترونية وهى كثيرة ومتنوعة فيمكنك العمل فى شركات الالكترونيات ، مصانع الأجهزة الكهربائية وغيرها كما يمكنك العمل بشكل مستقل وتبدأ مشروعك الخاص.';
        this.list = [];
        this.system = 'عامان دراسيان 4 ترم.';
        // tslint:disable-next-line: max-line-length
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- Medical -------------------------- */
      case '/medical':
        this.img1 = 'd01.png';
        this.img2 = 'd02.png';
        this.v2 = true;
        this.depName = 'قسم الخدمات الطبية';
        // tslint:disable-next-line: max-line-length
        this.vision = 'للقسم رؤية في أن يصبح مركزا للتميز يساهم في تطوير مفهوم التمريض وإعداد خريجين ذو مهارات علمية ويقدم معاون تمريض متميز يستطيع الاندماج في سوق العمل بكفاءة ومهارة عالية';
        // tslint:disable-next-line: max-line-length
        this.message = 'التمييز في مجال التعليم التمريضي والممارسة المهنية المتطورة لخريجي الأكاديمية لمواكبة العصر وتلبية احتياجات المجتمع للتعليم في مجال التمريض التي تركز على التعاون والمشاركة النشطة في التعلم، والتفكير النقدي لتطوير فهم واسع من المبادئ الأساسية بالتعليم في مجال التمريض يُمكن الخريجين من التأهيل أكاديمياً وعلميا وأخلاقيا للعمل بمجال التمريض';
        // tslint:disable-next-line: max-line-length
        this.objective = 'الهدف من قسم الخدمات الطبية هو إعداد كوادر تمريضية علمية و مهنية قادرة على الإبداع و إنتاج المعرفة و المنافسة وإعداد تدريسي متميز علمياً و مهنياً و ثقافياً وتقديم الرعاية الصحية الأولية العلاجية والوقائية بالمستشفيات التى يتم عمل الخريج بها - مباشرة الحالات الإسعافية الأولية ';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم القسم نخبة من أعضاء هيئة التدريس الاكفاء والمميزين في عملهم وذوي خبرة عالية وتحرص الأكاديمية على رفع كفاءة العاملين في القسم باستمرار سواء بحضور الندوات او الاشتراك بالدورات او الدراسات العملية والأكاديمية او حضور المؤتمرات الطبية';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يهدف لقسم الخدمات الطبية الى تاهيل الخريج ليكون له القابلية على القيام بمختلف الاعمال التمريضية في كافة التخصصات ويندمج داخل المجتمع الطبي والمستشفيات ويكون ذو كفاء عالية في مجال التمريض فى كافة نواحي المهنة ويكون ملم بآداب المهنة وحسن التعامل مع المرضى';
        this.list = [];
        this.branch = 'توفر الأكاديمية جميع الاجهزة المساعدة في العملية التعليمية الخاصة بمجال التمريض سواء التقليدية او الحديثة وتوفر فرص التدريب في كبرى المستشفيات';
        // tslint:disable-next-line: max-line-length
        this.programs = 'عامان دراسيان 4 ترم';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- IT -------------------------- */
      case '/it':
        this.img1 = 'f01.png';
        this.img2 = 'f02.png';
        this.depName = 'قسم تكنولوجيا المعلومات';
        // tslint:disable-next-line: max-line-length
        this.vision = 'تسعى أكاديمية 6 أكتوبر فى قسم تكنولوجيا المعلومات إلى توفير مقومات التطوير المستمر للتعليم فى مجال تكنولوجيا المعلومات لمواكبة التطورات العلمية والتكنولوجية المتسارعة، والارتقاء بخريجي القسم إلى مستوى التميز والقدرة التنافسية العالية';
        // tslint:disable-next-line: max-line-length
        this.message = 'تتبلور رسالة القسم في توظيف جميع خدمات تكنولوجيا المعلومات لتقديم حلول متميزة بغرض تحويل كافة الخدمات إلكترونيا بطريقة فعالة وكفؤة مبنية على المعرفة والشفافية- الالتزام بالمعايير والمستويات العالمية في نظم المعلومات الحاسوبية ومواكبة التقدم والتطور في مجال تكنولوجيا المعلومات والتركيز على متطلبات السوق الإلكترونية- تقديم أفضل البرامج الإلكترونية المستمدة من المؤسسات الأكاديمية ذات المستوى العالمي والحفاظ عليها بالإضافة إلى نشر المهارات المتعلقة بتصميم ذكي وتفاعلي لعلم تكنولوجيا المعلومات والاستفادة من قوة هذا العلم لتوفير الحلول المناسبة في السياقات التنظيمية';
        // tslint:disable-next-line: max-line-length
        this.objective = 'إعداد المتخصصين فى مجال تكنولوجيا المعلومات والشبكات وإدارتها والبرمجيات وقواعد البيانات وتأمين المؤهلين بالأسس النظرية ومنهجيات التطبيق بما يمكنهم من المنافسة العالمية فى تطوير تقنيات الحاسب والمعلومات ومواكبة التطور السريع في مجال تقنية وتكنولوجيا المعلومات';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم القسم نخبة من اعضاء هيئة التدريس من الاساتذة والمعيدين والمهندسين الاكفاء والمتميزين في عملهم وذوي خبرة عالية سواء اكاديمية او عملية';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يهدف القسم الى تأهيل الخريج ليكون قادر على القيام بالمهام سواء فى مجال البرمجيات او شبكات الحاسب او الجرافيك او المونتاج في كافة المنظمات العاملة في المجال ويكون ذو كفاء عالية ملم بكافة ما يتخصص به فى مجال تكنولوجيا المعلومات وحسن التعامل مع العاملين';
        this.list = [];
        this.subDeps = 'توفر الأكاديمية عدة شعب لتتماشى مع التطور الهائل فى مجال التكنولوجيا : شعبة البرمجة وتشمل برمجة الويب والتطبيقات لاجهزة الكمبيوتر والموبايل - ايضا شعبة شبكات الحاسب - شعبة الجرافيك - شعبة المونتاج - شعبة صيانة الحاسب'
        // tslint:disable-next-line: max-line-length
        this.programs = 'عامان دراسيان 4 ترم.';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- Business -------------------------- */
      case '/business':
        this.img1 = 'g01.png';
        this.img2 = 'g02.png';
        this.depName = 'قسم إدارة الأعمال';
        // tslint:disable-next-line: max-line-length
        this.vision = 'يهدف قسم إدارة الأعمال إلى تأهيل خريجين إداريين متميزين ذوى كفاءة ومهارة عالية لقيادة منظمات الأعمال في مجتمع المعرفة و إعداد الكوادر الإدارية وتطوير مهاراتهم وقدراتهم لمواكبة احتياجات سوق العمل في منشآت القطاعين العام والخاص ، للعمل فى الوزارات والهيئات وكبرى الشركات ومكاتب المحاسبة.';
        // tslint:disable-next-line: max-line-length
        this.message = 'إعداد وتأهيل خريجين على مستوى عال من الكفاءة  و الفاعلية لقيادة منظمات الأعمال و تلبية احتياجات سوق العمل محلياً وإقليميا ودولياً و تزويدِ الطلبةِ بالأسسِ العلميةِ لمُمارسةِ العمليةِ الإداريةِ بكفاءةٍ وفعالية بالاضافة الى إمداد القطاعين الخاص والعام بالكوادر المتخصصة والتي يحتاج إليها المجتمع في مواصلة عملية التنمية - تطوير المهارة الإدارية من خلال التركيز المتوازن على الأسس النظرية والأساليب التطبيقية الحديثة في مجال الأعمال';
        // tslint:disable-next-line: max-line-length
        this.objective = 'الارتقاء بخدمات التعليم والبحث العلمي و خدمة المجتمع بما يحقق أهداف التعليم المتميز القائم على تنمية المجتمع - فهم متطلبات الممارسة الإدارية في المنظمات - إعداد الأهداف للمنظمات والوحدات الإدارية - استخدام التكنولوجيات الحديثة في العملية الإدارية - توفير بيئة تعليمية متميزة لطلاب القسم وفق أحدث البرامج المعمول بها في الجامعات العالمية - إكساب الطلبة المعارف و المهارات الإدارية ،وتزويدهم بالمفاهيم والاتجاهات العلمية الإدارية الحديثة اللازمة من خلال التطبيق العملي لتلبية احتياجات سوق العمل - تنمية مهارات الإبداع و الابتكار والعمل الجماعي لدى الطلاب وبما يمكنهم في اتخاذ القرارات الإدارية لمعالجة المشكلات التي تواجه منظمات الأعمال - المساهمة في تقوية العلاقات مع قطاعات الأعمال ذات العلاقة بتخصص القسم ويحتوى المقرر الدراسى لطلاب القسم على مبادئ إدارة الأعمال، والسلوك التنظيمى وإدارة الموارد البشرية ووظائف الموارد البشرية ، بالإضافة إلى الإدارة بالمعرفة والجودة الشاملة وشئون العاملين كما يوفر القسم حزمة من البرامج التدريبية اللازمة والمناسبة للقسم وربطه بسوق العمل';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم قسم إدارة الأعمال نخبة من الأساتذة الحاصلين على درجتى الدكتوراه والماجستير من الجامعات المصرية ذوى الخبرة فى المجالات الإدارية المختلفة بهدف تزويد الطلاب بالمعارف والمهارات الإدارية الأساسية، وما يستحدث من المعارف والخبرات فى الفكر الإداري. ';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يؤهل قسم إدارة الأعمال إلى الأعمال الآتية : محاسب - موظف تسويق - مسوق إلكترونى - مدير إدارة - مدير عام - أخصائي تخطيط - موظف شئون عاملين.';
        this.list = [
        ];
        // tslint:disable-next-line: max-line-length
        this.system = 'عامان دراسيان 4 ترم.';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- Khyadia -------------------------- */
      case '/khyadia':
        this.img1 = 'h01.png';
        this.img2 = 'h02.png';
        this.v3 = true;
        this.depName = 'قسم التفصيل والخياطة';
        // tslint:disable-next-line: max-line-length
        this.vision = 'يهدف قسم التفصيل والخياطة بأكاديمية 6 أكتوبر الى تأهيل الخريج للعمل فني داخل مصانع التصدير والاتقان الكامل للتعامل مع مختلف ماكينات مصانع الملابس الجاهزة و الاشراف على خطوط الإنتاج';
        // tslint:disable-next-line: max-line-length
        this.message = 'تأهيل خريجي قسم التفصيل والخياطة للعمل بأكبر شركات تصدير الملابس عن طريق دراسة عملية وفنية متقدمة بما يسهم في تلبية احتياجات سوق العمل في مصانع انتاج الملابس الجاهزة العديدة والتي تحتاج الى فنيين أكفاء لتشغيل خطوط انتاج الملابس وتأهيل الدارسين بقسم التفصيل والخياطة بمعرفة تفاصيل خطوط الانتاج المختلفة من دراسة عمل وتحديد عدد الماكينات كل موديل تمهيدا للعمل بالأشراف المؤدي الى الادارة الإنتاجية.';
        // tslint:disable-next-line: max-line-length
        this.objective = 'فهم الافراد في فهم أهمية الوقت والانتاج والنظام والانتظام ومتطلبات صناعة الملابس الجاهزة وهي واحدة من ابسط المتطلبات مقارنة بأي صناعة اخرى ويمكن البدء في مشروع صناعي بإمكانيات بسيطة. فعلى الرغم من وجود أجهزة متطورة جدا في هذه الصناعة إلا انه يمكن البدء في مشروع ملابس جاهزة صغير بالاعتماد على بعض الماكينات البسيطة بشرط تعلم هذه الصناعة عن طريق الدراسة والممارسة وتعلم اساسيات التصنيع وكيفية الجلوس في خطوط انتاج وأهمية الوقت وأهمية الإنتاج';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم قسم التفصيل والخياطة نخبة من مديري المصانع ومشرفين خطوط انتاج وفنين صيانة الماكينات ومدربين لتعليم الجلوس على جميع انواع الماكينات من يعملون بمجال الملابس الجاهزة ولهم جميعا خبرة في ادارة وتنظيم خطوط الانتاج بمصانع الملابس الجاهزة';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'خطوط انتاج الملابس الجاهزة شركات التصدير العمل بمصانع الملابس الجاهزة مشروع شخصى.';
        this.list = [
        ];
        // tslint:disable-next-line: max-line-length
        this.system = 'عامان دراسيان 4 ترم.';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- Petrols -------------------------- */
      case '/petrols':
        this.img1 = 'j01.png';
        this.img2 = 'j02.png';
        this.depName = 'قسم الخدمات البترولية';
        // tslint:disable-next-line: max-line-length
        this.vision = 'تتطلع اكاديمية 6 أكتوبر إلى أن تتبوأ مكانة مرموقة بين مؤسسات التعليم في مصر وعلى المستوى الأقليمي إنطلاقاً من مساهمتها فى تطوير العملية التعليمة في مجال الخدمات البترولية وتفاعلها مع مجتمعها من ا من خلال تخريج فنيين متميزين قادرين على المنافسة محلياً وإقليميا.ً';
        // tslint:disable-next-line: max-line-length
        this.message = 'تهدف أكاديمية 6 أكتوبر المتخصصة في المجال التعليمى في الخدمات البترولية في إعداد نخبة من الفنيين المتخصصين في مجالات الخدمات البترولية لتفى بالمتطلبات المحلية والاقليمية من فنين تفيد هذا المجال وذلك من خلال الاهتمام بالعملية التعليمية وتنمية مهارات الخريج وتهيئته للالتحاق بكبرى الشركات العاملة في مجال البترول';
        // tslint:disable-next-line: max-line-length
        this.objective = 'يهدف قسم الخدمات البترولية لتخريج كوادر عالية على مستوي علمي وعملي فى مجال الخدمات البترولية بحيث يكون الخريج مثال يحتذى به من خلال عمله في الشركات الكبرى ويكون قادر على اداء خدمة مميزة ترقي بمستوى الشركة ويحصل الطالب على شهادة اخصائي معتمدة دوليا';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم القسم أفضل المهندسين والفنين الاكفاء والمتميزين في عملهم وذوي خبرة عالية سواء اكاديمية او عملية وتحرص الأكاديمية على رفع كفاءة العاملين في القسم باستمرار الاشتراك بالدورات او الدراسات العملية والأكاديمية';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يهدف القسم الى تأهيل الخريج ليكون قادر على القيام بمختلف اعمال الخدمات البترولية في كافة الشركات العاملة في المجال ويندمج داخل الشركة ويكون ذو كفاء عالية ملم بآداب المهنة وحسن التعامل مع العاملين';
        this.list = [
        ];
        this.branch = 'توفر الأكاديمية فرص التدريب في كبرى الشركات العاملة في مجال البترول في جميع المحافظات تحت اشراف كامل من المهندسين والفنين العاملين بالأكاديمية';
        // tslint:disable-next-line: max-line-length
        this.system = 'عامان دراسيان 4 ترم.';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      /* -------------------------- TV -------------------------- */
      case '/tv':
        this.img1 = 'c01.png';
        this.img2 = 'c03.png';
        this.v5 = true;
        this.depName = 'قسم الصحافة والإعلام';
        // tslint:disable-next-line: max-line-length
        this.vision = 'قسم الصحافة والاعلام يتميز قسم الصحافة والاعلام بتدريس المواد المتعلقة بالصحافة والاذاعة والتليفزيون والعلاقات العامة على يد نخبة متميزة من اعضاء هيئة التدريس والهيئة المعاونة وذلك  خلال عامان دراسيان تؤهل الطالب لسوق العمل فى المجال  الصحفي والإعلامي وفق ما يتطلبه من مؤهلات دراسية وتدريبية، ليصبح الطالب قادر على العمل كمراسل او محرر صحفي فى الصحف الورقية والالكترونية، او معد ومذيع فى كلا من الراديو والتليفزيون بالإضافة الى العلاقات العامة فى كبرى المؤسسات والشركات';
        // tslint:disable-next-line: max-line-length
        this.message = 'تحقيق مكانة متقدمة بين افضل اكاديميات الصحافة والاعلام في مصر والوطن العربي من خلال تأهيل الخريجين للمنافسة في سوق العمل المحلي والوطني والعالمي فى المجال الصحفي والإعلامي لتكون الاكاديمية في مقدمة الاكاديميات المصرية والعربية للصحافة والإعلام, وتسعى الى ان يكتسب ثقة المجتمع في خريجيه من خلال توفير بيئة متميزة وتنافسية للتعليم والتعلم والبحث العلمي وخدمة المجتمع';
        // tslint:disable-next-line: max-line-length
        this.objective = 'يهدف القسم إلى تزويد الطلبة بالمعلومات النظرية والعملية في مجال الصحافة على النحو الآتي تدريب الطلبة على فن ومهارات الكتابة الصحفية تدريب الطلبة على فن ومهارات القيام بالتحقيقات الصحفية- تدريب الطلبة على فن ومهارات جميع المعلومات وتصنيفها وكتابتها في خبر وتحريرها ونشرها- تدريب الطلبة على فن ومهارات نقل الحقيقة للجمهور وكشف الزيف والتضليل الاعلامي- تدريب الطلبة على فن ومهارات صياغة الرسائل الإعلامية الدقيقة والموضوعية والواضحة والأخلاقية- تدريب الطلبة على فن ومهارات إعداد وكتابة ونشر الابحاث العلمية تدريب الطلبة على معرفة الانظمة والتعليمات والقوانين والمواثيق التي تنظم عمل الصحافة.';
        // tslint:disable-next-line: max-line-length
        this.teachers = 'يضم القسم نخبة من الاساتذة والمعيدين لتدريس المواد الأكاديمية لقسم الصحافة والإعلام.';
        // tslint:disable-next-line: max-line-length
        this.jobs = 'يؤهل قسم الصحافة والاعلام إلى الأعمال الآتية : محرر صحفي / معد تليفزيوني/ معد برامج / مراسل.';
        this.list = [
        ];
        // tslint:disable-next-line: max-line-length
        this.system = 'عامان دراسيان 4 ترم.';
        this.degree = 'يحصل الطالب على شهادة معتمدة من كبرى الجامعات المصرية للعمل داخل مصر وتصدق من وزارة الخارجية المصرية للعمل خارج مصر';
        break;
      default:
        break;
    }
  }

  getSectionData(id) {
    this.api.getSectionByID(id).subscribe(
      data => {
        //debugger
        //console.log(data);
        //alert(data[0].name);
        this.sectionData = data;
        this.depName = data[0].name;
        this.img1 = data[0].image1;
        this.img2 = data[0].image2;
        this.vision = data[0].vision;
        this.message = data[0].message;
        this.objective = data[0].objectives;
        this.teachers = data[0].staff;
        this.jobs = data[0].job_desc;
        this.system = data[0].edu_system;
        this.degree = data[0].certificate;
        this.video_url = data[0].video_url;
        this.video_url = this.domSanitizer.bypassSecurityTrustResourceUrl(data[0].video_url);
       // alert(this.video_url);
        if (data[0].video_url != "")
          this.v1 = true;
        else this.v1 = false;
      }, error => {
        console.log(error);
      });

  }
  createForm() {
    this.register = this.fb.group({
      nationalId: ['', Validators.required],
      name: ['', Validators.required],
      qualification: ['', Validators.required],
      graduateYear: ['', Validators.required],
      sectionId: ['', Validators.required],
      branchId: ['', Validators.required],
      grade: "222",
      acquaintanceWay: ['', Validators.required],
      phone: ['', Validators.required],
      stateId: ['', Validators.required],
      cityId: "3",
    });
  }

  loadData() {
    // public years: any[];
    this.years = this.api.getYears();
    //console.log(this.years);

    this.api.getSection().subscribe(
      data => {
        //debugger
        // console.log(data["data"]);
        this.sections = data["data"];
      }, error => {
        console.log(error);
      });

    this.api.getBranches().subscribe(
      data => {
        //debugger
        // console.log(data["data"]);
        this.branches = data["data"];
      }, error => {
        console.log(error);
      });

    this.api.getAcquaintance().subscribe(
      data => {
        //debugger
        //console.log(data["data"]);
        this.conns = data["data"];
      }, error => {
        console.log(error);
      });

    this.api.getQualification().subscribe(
      data => {
        //debugger
        //  console.log(data["data"]);
        this.quals = data["data"];
      }, error => {
        console.log(error);
      });

    this.api.getGovernorate().subscribe(
      data => {
        //debugger
        // console.log(data["data"]);
        this.govs = data["data"];
      }, error => {
        console.log(error);
      });

  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  onSend(form) {
    console.log(form);
    this.api.createEnquiry(form).subscribe(
      response => {
        //debugger
        // console.log(response["status"]);
        Swal.fire({
          title: 'شكراً لك',
          confirmButtonText: 'نعم',
          icon: 'success'
        });
        this.createForm();

        this.modalRef.hide();
        console.log(response);
      }, error => {
        console.log(error);
        Swal.fire({
          title: 'حدث خطا يرجي المحاوله مره اخر',
          confirmButtonText: 'نعم',
          icon: 'error'
        });
      });
  }


  ngOnInit() {

    this.loadData();

    window.scrollTo(0, 0);
  }
}
